<template>
  <div class="lg:w-80 xl:w-96 shrink-0">
    <ClaimAssigneeCard class="mb-3" :claim="claim" />

    <IntercomConversationList v-if="claim.customer?.email" :customer-email="claim.customer.email" class="mb-3" />

    <div class="bg-white rounded-2xl shadow-md p-4">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-lg font-bold text-gray-900">Historique</h3>
        <SecondaryButton size="sm" @click="$emit('add-note')">Ajouter une note</SecondaryButton>
      </div>
      <ClaimHistoricalChanges :claim="claim" />
    </div>

    <PlanSaleInformation class="mt-3" :claim="claim" />
  </div>
</template>

<script>
import { SecondaryButton } from "@estaly/ui";
import ClaimAssigneeCard from "@/components/claim/details/ClaimAssigneeCard.vue";
import ClaimHistoricalChanges from "@/components/claim/details/information/ClaimHistoricalChanges.vue";
import PlanSaleInformation from "@/components/claim/details/information/PlanSaleInformation.vue";
import IntercomConversationList from "@/components/intercom/IntercomConversationList.vue";

export default {
  components: {
    SecondaryButton,
    ClaimAssigneeCard,
    ClaimHistoricalChanges,
    PlanSaleInformation,
    IntercomConversationList,
  },

  emits: ["add-note"],

  props: {
    claim: {
      type: Object,
      required: true,
    },
  },
};
</script>
